import { render } from "./aboutus.vue?vue&type=template&id=0f6a0db4&scoped=true"
import script from "./aboutus.vue?vue&type=script&lang=js"
export * from "./aboutus.vue?vue&type=script&lang=js"

import "./aboutus.vue?vue&type=style&index=0&id=0f6a0db4&lang=scss&scoped=true"

import exportComponent from "/Users/waiting/Desktop/代码库/musich5/代码/musicweapons/frontend/music/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6a0db4"]])

export default __exports__